import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledSearchContainer, StyledSearchWrapper, StyledSearch } from './styled';
import IconButton from '../IconButton';
import Icon from '../Icon';
import useTheme from '../../hooks/useTheme';
import { useTranslation } from 'react-i18next';

const Search = forwardRef(({ id, placeholder, name, value, autoComplete, onChange, expanded, onClickSearchIcon, fullWidth, small }, ref) => {
  const { t } = useTranslation()
  const theme = useTheme();
  
  return (
    <StyledSearchContainer
      small={small}
      expanded={expanded}
      fullWidth={fullWidth}
    >
      <StyledSearchWrapper>
        <StyledSearch
          ref={ref}
          id={id}
          placeholder={placeholder || t('Szukaj')}
          name={name}
          onChange={onChange}
          value={value}
          autoComplete={autoComplete}
        />
      </StyledSearchWrapper>
      <IconButton
        onClick={onClickSearchIcon}
      >
        <Icon
          name="magnifier"
          fill={theme.colors.purple}
          height="16"
          width="16"
        />
      </IconButton>
    </StyledSearchContainer>
  )
});

Search.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  autoComplete: PropTypes.oneOf(['on', 'off']),
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onClickSearchIcon: PropTypes.func,
};

Search.defaultProps = {
  autoComplete: 'on',
  onChange: undefined,
  expanded: true,
  fullWidth: false,
  onClickSearchIcon: undefined
};

export default React.memo(Search);